import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

import { tryToUpdateEmail, tryToFetchMyAccountInfo } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomField from '../CustomField/CustomField.js'

class UserSettingsEmailForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      email: props.user.emailForm.lastSubmit.email || props.user.email,
      public_email: props.user.public_email,
    }

    this.togglePublicEmail = this.togglePublicEmail.bind(this);
    this.handleUpdateEmail = this.handleUpdateEmail.bind(this);
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  togglePublicEmail(){
    var c = this.state.public_email;
    this.setState({
      public_email: c ? false : true
    })
  }

  handleUpdateEmail(e){
    const { dispatch } = this.props;
    
    dispatch(tryToUpdateEmail({
      email: this.state.email
    }))
    if(e) e.preventDefault();
  }


  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    let formDisabled = !state.email;

    return (
      <div>
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleUpdateEmail(e); 
        }}>
          <CustomField 
            type="text"
            regex="email"
            name="email"
            placeholder="email address"
            label="Email"
            onChange={(e) => { this.setState({email: e}); }}
            serverErrors={user.emailForm.errors.email}
            required={true}
            disabled={user.tryingToUpdateEmail}
            />
          <p className="text-thin-line-height">
            After changing your email address, you'll need to click the verification link in the email sent to the new address.
          </p>
          <div className="list-right">
            <Button 
              submit={true}
              size="medium" 
              disabled={formDisabled} 
              thinking={user.tryingToUpdateEmail} 
              successful={user.successfullyUpdatedEmail}
              failed={user.failedToUpdateEmail}
              color="success" 
              display="Save Changes" 
              onClick={this.handleUpdateEmail}
            />
          </div>
        </form>
      </div>
    )
  }
}


UserSettingsEmailForm = reduxForm({
  // a unique name for the form
  form: 'UserSettingsEmailForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(UserSettingsEmailForm)

UserSettingsEmailForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    email: user.email
  };
  

  return {
    user,
    initialValues
  }
})(UserSettingsEmailForm);

export default UserSettingsEmailForm;



// WEBPACK FOOTER //
// ./src/components/UserSettingsEmailForm/UserSettingsEmailForm.js